import type { Certificate } from '../../domain'

export interface CertificatesService {
    /**
     * Fetches certificates
     * @throws {import('../../domain').ConnectwareError}
     */
    fetchCertificates(): Promise<readonly Certificate[]>

    /**
     * Deletes given certificate
     * @throws {import('../../domain').ConnectwareError}
     */
    delete(certificate: Certificate): Promise<void>

    /**
     * Uploads new certificate
     * @throws {import('../../domain').ConnectwareError}
     */
    upload(certificateContent: string): Promise<Certificate>

    /**
     * Returns the content of the given certificate
     * @throws {import('../../domain').ConnectwareError}
     */
    fetchCertificateFileContent(certificate: Certificate): Promise<string>
}
